import { Navigate } from 'react-router-dom';

const PublicRoutes = (props) => {

    const { status, children } = props

    return (status === 'not-authenticated' )
        ? children
        : <Navigate to="/inicio" />
}

export {
    PublicRoutes
}